import { useRouter } from 'next/router';
import { useLocaleContext } from 'providers/LocaleProvider';
import React, { useEffect, useRef, useState } from 'react';
import Select, {
  SelectSearch,
  SelectList,
  SelectOption,
} from '@seaweb/coral/components/Select';
import { useSearchContext } from 'providers/SearchProvider';
import ElkHighlighter from 'components/shared/ElkHighlighter';
import { object } from 'prop-types';
import styled from 'styled-components';
import StyledSearchIcon from 'components/search/StyledSearchIcon';

const StyledSelectSearchWrapper = styled.div`
  position: relative;
`;

const StyledSelectSearch = styled(SelectSearch)`
  width: calc(100vw - 48px);
  max-width: 800px;
  background-color: white;
  padding-left: 45px;
  border-radius: 4px;

  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    font-size: 16px;
  }
`;

const StyledSelectList = styled(SelectList)`
  transform: none !important;
  position: absolute !important;
  top: 50px !important;
  bottom: unset !important;
  z-index: 5 !important;
`;

function HomeSearchField({ style }) {
  const searchRef = useRef();
  const searchInputRef = useRef(null);
  const [isRendered, setIsRendered] = useState(false);
  const { push } = useRouter();
  const { locale: t } = useLocaleContext();
  const { keyword, setKeyword, articles } = useSearchContext();

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setKeyword('');
      push(`/search?keyword=${keyword}`);
    }
  };

  const overrideResetText = (state, { action, nextState }) => {
    if (action.type === 'inputBlur') {
      const overrideState = nextState;
      overrideState.value = state.value;
      return overrideState;
    }
    return nextState;
  };

  useEffect(() => {
    // Work around to make StyledSelectList render correctly with container
    setIsRendered(true);
  }, []);

  return (
    <StyledSelectSearchWrapper ref={searchRef}>
      <Select
        onSearch={(word) => setKeyword(word)}
        stateReducer={overrideResetText}
        onSelect={(val) => {
          if (searchInputRef.current) {
            searchInputRef.current.blur();
          }
          push(`/categories/${val[0]}/article/${val[1]}`);
        }}
      >
        {/* using StyledSearchIcon here because leftElement of SelectSearch of Coral does not work */}
        <StyledSearchIcon size={20} />
        <StyledSelectSearch
          placeholder={t('hc.search.question_keywords')}
          ref={searchInputRef}
          style={style}
          onKeyPress={handleKeyPress}
          onChange={(e) => setKeyword(e.target.value.slice(0, 127))}
          rightElement={null}
        />

        {isRendered && articles && articles.articles && (
          <StyledSelectList container={searchRef.current}>
            {articles.articles.map((article) => (
              <SelectOption
                value={[article.category.id, article.id]}
                key={article.id}
              >
                <ElkHighlighter text={article.title} />
              </SelectOption>
            ))}
          </StyledSelectList>
        )}
      </Select>
    </StyledSelectSearchWrapper>
  );
}

HomeSearchField.propTypes = {
  style: object,
};

HomeSearchField.defaultProps = {
  style: {},
};

export default HomeSearchField;
